import React from 'react';
import KanjiLookup from '../components/KanjiLookup';
import ChineseLookup from '../components/ChineseLookup';
import TinySegmenter from './tinySegmenter';

const processSentenceJisho = (input) => {
    let sentence = input;
    if (typeof sentence !== 'string') {
        if (sentence && typeof sentence.targetSentence === 'string') {
            sentence = sentence.targetSentence;
        } else {
            return sentence;
        }
    }

    // If there are no Japanese or Chinese characters, return the sentence as-is.
    if (!/[\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF]/.test(sentence)) {
        return sentence;
    }

    // Check if the text contains Chinese characters without any Japanese-specific characters
    // This detection logic caused issues with highlighting saved Japanese words
    const containsJapaneseChars = /[\u3040-\u309F\u30A0-\u30FF]/.test(sentence);
    const containsChineseOnly = /[\u4E00-\u9FFF]/.test(sentence) && !containsJapaneseChars;

    const segmenter = new TinySegmenter();
    const words = segmenter.segment(sentence);

    // Create a container element to avoid adding spaces between elements
    return (
        <span className={containsChineseOnly ? "chinese-sentence" : "japanese-sentence"}>
            {words.map((word, index) => {
                if (/[\u4E00-\u9FFF\u3040-\u309F\u30A0-\u30FF]/.test(word)) {
                    // Use ChineseLookup only for Chinese text without Japanese characters
                    if (containsChineseOnly) {
                        return (
                            <ChineseLookup 
                                key={`hanzi-${index}`} 
                                word={word} 
                                sentence={sentence}
                            >
                                {word}
                            </ChineseLookup>
                        );
                    } else {
                        return (
                            <KanjiLookup 
                                key={`kanji-${index}`} 
                                word={word} 
                                sentence={sentence}
                            >
                                {word}
                            </KanjiLookup>
                        );
                    }
                }
                return <React.Fragment key={`text-${index}`}>{word}</React.Fragment>;
            })}
        </span>
    );
};

export default processSentenceJisho;
